/**
 * Colores del chip de mención. Viven acá y no en `HistorySection` porque los usan los dos lados:
 * el render de la nota en el timeline y el espejo del input (`MentionsInput`). Duplicar el verde
 * era garantía de que en algún momento uno de los dos quedara distinto.
 */

/** Verde de marca (theme.colorPrimary). Actores y links del timeline. */
export const BRAND = "#15744b";

/**
 * Fondo del chip de mención: el MISMO verde de marca al ~10% (alpha en hex, `1a` = 26/255).
 * Derivado de BRAND a propósito, no un verde nuevo: si cambia el tema, el tinte lo sigue.
 * Sobre blanco queda ≈ #e8f1ed, así que el texto BRAND mantiene contraste de sobra.
 */
export const MENTION_BG = `${BRAND}1a`;
